import { api, REQUEST_TYPE } from 'store/api'
import { logError } from 'utils/logUtils'
import { mapErrorPayload } from 'utils/mappers/logMappers'

export const PlaygroundTasks = api.injectEndpoints({
  endpoints: build => ({
    listTasks: build.query({
      query: () => ({
        type: REQUEST_TYPE.GET,
        path: '/playground/v1/tasks'
      }),
      transformResponse: res => res.tasksList
    }),
    fetchTaskDetails: build.query({
      query: taskId => ({
        type: REQUEST_TYPE.GET,
        path: `/playground/v1/tasks/${taskId}`
      }),
      transformResponse: res => res.task
    }),
    executeTask: build.mutation({
      query: ({ taskId, args }) => ({
        type: REQUEST_TYPE.POST,
        path: '/playground/v1/tasks',
        data: {
          taskId,
          args
        }
      }),
      transformErrorResponse: err => {
        const message = err.response?.data?.message || 'An error occurred while executing the task.'
        const requestId = err.response?.data?.requestId || 'Unknown'
        logError('PlaygroundTasks - executeTask error', { error: mapErrorPayload(err), requestId })
        return `${message} (Request ID: ${requestId})`
      }
    })
  })
})

export const { useListTasksQuery, useFetchTaskDetailsQuery, useExecuteTaskMutation } = PlaygroundTasks
